export const canWriteDiscounts = (scopes: string[]) => {
    return scopes.includes('discounts:write') ||
    scopes.includes('admin:discounts') ||
    scopes.includes('write:discounts');
};

export const canReadProducts = (scopes: string[]) => {
    return scopes.includes('read:products') ||
    scopes.includes('admin:products');
};
